import React from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const Email = (props) => {
    const { t } = useTranslation();
    return (
        <Form.Group className="mb-3" controlId={props.id}>
            <Form.Label className="w-100">
                {t("email")} <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
                value={props.value}
                onChange={props.onChange}
                onClick={props.onClick ? props.onClick : null}
                placeholder={t("emailPlaceholder")}
                type="email"
                autoComplete="email"
                disabled={props.blockForm}
            />
        </Form.Group>
    );
};

export default Email;
